export default "__VITE_ASSET__ZHp5pm$B__"